import { registerPlugin } from '@capacitor/core';
const CapacitorUtils = registerPlugin('CapacitorUtils', {
    web: () => import('./web').then(m => new m.CapacitorUtilsWeb()),
});
export * from './definitions';
export { CapacitorUtils };
//# sourceMappingURL=index.js.map